<template>
  <div :class="backgroundClasses">
    <div class="hashtag-modal-wrapper">
      <div class="title-row">
        <h1>Hashtags</h1>
        <button v-on:click="onPressClose">
          <img :src="closeImgSrc" alt="close">
        </button>
      </div>
      <div class="tags-wrapper">
        <hash-tag-list
          :force-show-more="forceShowMore"
          :theme="theme"
          :tags="tags"
        ></hash-tag-list>
      </div>
    </div>
  </div>
</template>

<script>
import HashTagList from './HashTagList.vue';
// Vue1 `require('...svg')` -> ES-module import so Vite resolves the asset
// (inlined as a data URI under the build's assetsInlineLimit).
import closeSvg from '../../assets/v3-assets/close.svg';

export default {
  name: 'hashtag-modal',
  data() {
    return {
      forceShowMore: true,
    };
  },
  computed: {
    closeImgSrc() {
      return closeSvg;
    },
    backgroundClasses() {
      if (this.isVisible) {
        return 'background visible';
      }

      return 'background';
    },
  },
  components: { HashTagList },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    onPressClose: {
      type: Function,
      default: () => {},
    },
    theme: {
      type: Object,
      validator(value) {
        return ['light', 'dark', 'custom'].includes(value.type);
      },
    },
    tags: {
      type: Array,
      default() {
        return [
          { id: 1, name: 'label', station: 'WPHM' },
          { id: 2, name: 'label2', station: 'WPHM' },
          { id: 3, name: 'label3', station: 'WPHM' },
        ];
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.background {
  background-color: #E5E5E5;
  padding: 16px;
  display: none;
  z-index: 100;
  position: fixed;
  top: 0px;
  left: 0px;
  height: 100%;
  width: 100%;
}

.background.visible {
  display: flex;
  justify-content: center;
  align-items: center;
}

.hashtag-modal-wrapper {
  font-family: sans-serif;
  padding: 16px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 1px 3px rgba(34, 32, 70, 0.2);
  height: 100%;
  overflow: hidden;
  width: 100%;

  .title-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 18px;

    h1 {
      font-weight: 500;
      margin: 0px;
      padding: 0px;
    }
    button {
      border: none;
      background: none;

      &:hover {
        cursor: pointer;
      }
    }
  }
}

.tags-wrapper {
  margin: 0px;
  height: 80%;
  overflow: auto;
  overflow-x: hidden;
}
</style>
